"use strict";
import { ensure0xHex } from "utils/hex";
const DELEGATE_PREFIX = "ef0100";
const DELEGATE_LENGTH = 46;
export function isDelegatedEOA(input) {
  const { bytecode } = input;
  if (bytecode === "0x") {
    return { isDelegated: false, delegateTo: null };
  }
  const bytecodeWithoutPrefix = bytecode.startsWith("0x") ? bytecode.slice(2).toLowerCase() : bytecode.toLowerCase();
  if (bytecodeWithoutPrefix.startsWith(DELEGATE_PREFIX) && bytecodeWithoutPrefix.length === DELEGATE_LENGTH) {
    const delegateAddress = ensure0xHex(bytecodeWithoutPrefix.replace(DELEGATE_PREFIX, ""));
    return { isDelegated: true, delegateTo: delegateAddress };
  }
  return { isDelegated: false, delegateTo: null };
}
